import PartMessage from './PartMessage'
import {
  Delete,
  Error,
  HomeRepairService,
  Info,
  KeyboardArrowDown,
  KeyboardArrowUp,
  NotInterested,
  Store,
  Warning,
} from '@mui/icons-material'

import { show, show as showNiceModal } from '@ebay/nice-modal-react'
import Check from '@mui/icons-material/Check'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import { Menu, MenuItem, Skeleton } from '@mui/material'
import {
  removeProductThunk,
  getInCartProductQty,
  getCartMode,
  isThereOnlyTheMiscellaneousCart,
} from 'cart'
import {
  I18n,
  MY_PLACE_SELLER,
  StorageKeys,
  useBrandImage,
  ABSOLUTE_MAX_QUANTITY,
} from 'common'
import {
  IdValueGeneric,
  InventoryDisplay,
  NonCachedSearchType,
  ProductModel,
} from 'interfaces'
import { observer } from 'mobx-react-lite'
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useNavigate } from 'react-router-dom'
import SelectCartDrawer from '../SelectCartDrawer'
import { useSellerStore } from 'src/store/search/SellerStore'
import styled from 'styled-components'
import { EmbeddedCommunicationsManager } from '../../../../../../src/api/embedded/EmbeddedCommunicationsManager'
import { AddToListDrawer } from '../../../../../../src/features/search/Results/AddToListDrawer'
import miscellaneousVehicle from '../../../../../../src/features/search/Results/utils/miscellaneousVehicle'
import { getProductKey } from '../../../utils/productKeyUtil'
import { VehicleFitmentDrawer } from '../../../../../../src/features/vehicleFitment/components/VehicleFitmentDrawer'
import { getInterchangeParts } from '../../../../../../src/helpers/getInterchangeParts'
import { LocationType } from '../../../../../../src/helpers/locationType'
import { StoreInstances } from '../../../../../../src/store/StoreInstancesContainer'
import { CartMode } from '../../../../../../src/store/models/ShoppingCartModels'
import { CatalogNodeType } from '../../../../../../src/store/partsCatalog/interfaces'
import { useBannerPromotionStore } from '../../../../../../src/store/promotion/BannerPromotionStore'
import { useSearchStore } from '../../../../../../src/store/search/SearchStore'
import { useUiStateStore } from '../../../../../../src/store/uiState/UiStateStore'
import { useUserStore } from '../../../../../../src/store/user/UserStore'
import { UserAttributeKey } from '../../../../../../src/store/user/interfaces'
import { breakpoints } from '../../../../../../src/theme/breakpoints'
import { defaultTheme } from '../../../../../../src/theme/index'
import { Button } from '../../../../../../src/ui-components/forms/Button'
import {
  AlternateTag,
  ReplacementTag,
} from '../../../../../../src/ui-components/products/ProductTags'
import { QuantitySelector } from '../../../../../../src/ui-components/products/QuantitySelector'
import { Thumbnail } from '../../../../../../src/ui-components/products/Thumbnail'
import { useQuantitySelectorToolbox } from '../../../../../../src/ui-components/products/useQuantitySelectorToolbox'
import gfxCatalogIcon from '../../../assets/images/component_exchange.svg'
import carIcon from '../../../assets/images/might-not-match-vehicle.svg'
import { useResultsStore } from '../../../store/ResultsStore'
import { MultiSellerInterchangeTooltip } from '../MultiSellerInterchangeTooltip'
import { ReportLostSaleDrawer } from '../ReportLostSaleDrawer'
import Prices from './Prices'
import { useSelector } from 'react-redux'
import WarningLabel from 'src/features/WarningLabel'
import { storeInfo } from 'src/helpers/StoreInfo'
import { RootState, store } from 'store'
import LaborLookupDrawer from '../../../../../../src/features/labor/lookup/LookupDrawer'
import { Vehicle } from '../../../../../../src/store/models/Vehicles'
import { useProductInfo } from '../../../hooks/useProductInfo'

interface ProductCardProps {
  product: ProductModel
  alternateFor?: ProductModel
  replacementFor?: ProductModel
  green?: boolean
  index?: number
}

export const ProductCardDesktop = observer(
  ({
    alternateFor = undefined,
    replacementFor = undefined,
    product,
    green,
  }: ProductCardProps): ReactElement => {
    const navigate = useNavigate()
    const uiStore = useUiStateStore()
    const { getSelectedSeller } = useSellerStore()
    const {
      setShowBrandLinksDrawer,
      setShowLaborResultSearchResultsModal,
      isCondensedView,
      isMultiLocationEnabled,
    } = uiStore
    const resultsStore = useResultsStore()
    const {
      lastNonCachedSearch,
      setMultiPartInquiryResults,
      showAddAlltoCart,
      sellerDetails,
    } = resultsStore
    const searchStore = useSearchStore()

    const selectedCurrentVehicle = searchStore.currentVehicle?.engine
      ? searchStore.currentVehicle
      : miscellaneousVehicle

    const { cartProduct } = useProductInfo({
      product,
    })

    const {
      updateQuantity,
      inCart,
      currentQty,
      showLocationSelector,
      handleAddVehiclePartToCart,
      priceSpinner,
      inCartText,
      activeLocation,
      isZeroCost,
      disableAddToCart,
      setCurrentQty,
      setPriceSpinner,
      inStockSomewhere,
      orderIfNotAvailable,
      invDisplayState,
      getNonPrimaryLocationsQtyAvailable,
      getPrimaryLocationQtyAvailable,
      getOtherLocationsQtyAvailable,
    } = cartProduct

    const [addToCartInProgress, setAddToCartInProgress] = useState(false)

    const { handleCoverageMatch } = useBannerPromotionStore()

    const {
      partImages,
      description,
      extendedDescription,
      fromYear,
      perCarQty,
      lineCode,
      partNumber,
      orderNumber,
      isStocked,
      isExatcMatch,
    } = product

    const userStore = useUserStore()

    const hideRoutingDiagramContent = description === 'Routing Diagram'

    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    const { userId } = StoreInstances.userStore.preferences
    const { warrantyDescription, qtyAvailable, locType, called } =
      activeLocation || {}

    const contactNumber: string =
      storeInfo.getContactAdressInfo()?.phone?.phoneNumber || ''

    const vehicleFitment = sellerDetails
      ? sellerDetails.coverageKey === '' &&
        userStore?.preferences?.epeFeatures_buyersGuide === 'true'
      : userStore?.preferences?.epeFeatures_buyersGuide === 'true'

    const thumbnail = partImages?.length
      ? partImages.find((img) => img.type === 'thumbnail')?.url
      : ''
    const largerThumbnail = partImages?.length
      ? partImages.find((img) => img.type === 'large')?.url
      : null
    const productImage = largerThumbnail ?? thumbnail

    const [brandImgUrl] = useBrandImage(product)

    const extenDescSupposeLength = isCondensedView ? 15 : 65
    const [showFullDesc, setShowFullDesc] = useState(
      !extendedDescription ||
        extendedDescription.length < extenDescSupposeLength
    )

    const showNonASTLinks =
      !EmbeddedCommunicationsManager.isAstPunchOut &&
      resultsStore.lastNonCachedSearch !==
        NonCachedSearchType.searchByAstNavigation

    const shouldShowLaborLink =
      lastNonCachedSearch !== NonCachedSearchType.searchByInterchange &&
      lastNonCachedSearch !== NonCachedSearchType.searchByText &&
      lastNonCachedSearch !== NonCachedSearchType.searchByMultiPartsInquiry &&
      searchStore.currentVehicle?.type?.id === 111 &&
      userStore.getUserAttribute(UserAttributeKey.epeFeatures_labor) === 'true'

    const isApplicationPart = (): boolean => {
      return !searchStore?.showPartsNotFitVehicle
    }

    const showDrawer = (): void => {
      if (!inCart) {
        show(SelectCartDrawer, {
          product,
          handleAddVehiclePartToCart,
          activeLocation,
          ...(isMultiLocationEnabled() && { showLocationSelector }),
          seller: getSelectedSeller(),
          currentVehicle: searchStore.currentVehicle,
        })
        // searchStore.handleOpenNonAppProductModal({
        //   product,
        //   locationId: activeLocation?.locationId,
        //   quantity: currentQty,
        //   vehicle: searchStore.currentVehicle,
        //   handleAddVehiclePartToCart,
        // })
      }
    }

    const handleAddToCart = async (): Promise<void> => {
      if (inCart) return

      await shouldShowLocationSelector()

      handleCoverageMatch(orderNumber)

      const isSingleCartMode = getCartMode() === CartMode.SINGLE_VEHICLE

      const isInterchangeSearch =
        resultsStore.lastNonCachedSearch ===
        NonCachedSearchType.searchByInterchange

      const isOnlyTheMiscellaneousCart = isThereOnlyTheMiscellaneousCart()

      const targetVehicle = searchStore.currentVehicle?.engine?.id
        ? searchStore.currentVehicle
        : miscellaneousVehicle

      if (isSingleCartMode) {
        await addPartToCart(targetVehicle)
      } else {
        if (isInterchangeSearch) {
          // https://praxent.atlassian.net/browse/BABW-85?focusedCommentId=65782
          if (
            isOnlyTheMiscellaneousCart &&
            !searchStore.currentVehicle?.engine?.id
          ) {
            await addPartToCart(miscellaneousVehicle)
          } else {
            showDrawer()
          }
        } else if (isEligibleApplicationPart()) {
          await addPartToCart(searchStore.currentVehicle)
        } else if (!isOnlyTheMiscellaneousCart) {
          showDrawer()
        } else {
          await addPartToCart(targetVehicle)
        }
      }
    }

    const currentQtyInCart = useSelector((state: RootState) =>
      getInCartProductQty(
        state,
        selectedCurrentVehicle,
        sellerDetails?.coverageKey ?? '',
        product,
        activeLocation?.locationId
      )
    )

    useEffect(() => {
      if (inCart && currentQtyInCart > 0) {
        setCurrentQty(currentQtyInCart)
      }
    }, [currentQtyInCart, inCart, setCurrentQty])

    const addPartToCart = async (vehicle: Vehicle): Promise<void> => {
      setAddToCartInProgress(true)
      await handleAddVehiclePartToCart(vehicle)
      setAddToCartInProgress(false)
    }

    const isEligibleApplicationPart = (): boolean => {
      return (
        isApplicationPart() && Boolean(searchStore.currentVehicle?.engine?.id)
      )
    }

    const handleAddToList = () => {
      showNiceModal(AddToListDrawer, {
        product,
        currentQty,
      })
    }
    const handleClickVehicleFitment = () => {
      showNiceModal(VehicleFitmentDrawer, {
        product,
      })
    }

    const handleLostSale = () => {
      showNiceModal(ReportLostSaleDrawer, {
        product,
        quantity: currentQty,
        lostSaleCost: {
          list: activeLocation?.list,
          cost: activeLocation?.cost,
        },
        vehicle: searchStore.currentVehicle,
        lastNonCachedSearch: searchStore.lastNonCachedSearch,
        activeLocation,
      })
    }

    const handleLaborLookup = () => {
      showNiceModal(LaborLookupDrawer, {
        vehicle: searchStore.currentVehicle,
        product,
        setLaborResult: setShowLaborResultSearchResultsModal,
      })
    }

    const findGroupValue = (id: string): string => {
      return StoreInstances.partsCatalog.findNode(id, CatalogNodeType.GROUP)
        ?.value
    }

    const getCategoryId = (id: string): string => {
      let categoryId = null
      StoreInstances.partsCatalog.categoryGroups().forEach((category) => {
        category.getChildren().forEach((group) => {
          if (parseInt(group.id, 10) === parseInt(id, 10)) {
            categoryId = category.id
          }
        })
      })
      return (categoryId || '').toString()
    }

    const parseAllEngines = (
      item: IdValueGeneric<string, string>,
      categoryId: string
    ) => {
      const allEnginesSelected =
        searchStore.currentVehicle?.engine?.value === 'All Engine'
      searchStore.setGfxItem({
        id: item.id,
        value: item.value,
      })
      searchStore.setGroupId(categoryId)
      if (allEnginesSelected) {
        uiStore.setShowEnginesModal(true)
        searchStore.getEngineOptions()
      } else {
        searchStore.openGFX()
      }
    }

    const navigateToProductDetails = () => {
      const multiSellerParams = getSelectedSeller()?.coverageKey
        ? `&coverageKey=${getSelectedSeller().coverageKey}`
        : ''
      const productKey = getProductKey(product)
      sessionStorage.setItem(StorageKeys.SCROLL_TO_PRODUCTKEY, productKey)
      navigate(
        `/product/?partNumber=${product.partNumber}&lineCode=${product.lineCode}${multiSellerParams}`,
        { state: JSON.parse(JSON.stringify(product)) }
      )
    }

    const showGFX =
      searchStore.currentVehicle?.year?.id >= 2000 &&
      userStore.getUserAttribute(UserAttributeKey.GFX_Enabled) === 'true' &&
      !replacementFor &&
      !alternateFor &&
      product?.isGfx

    useEffect(() => {
      if (showAddAlltoCart)
        setMultiPartInquiryResults(product, activeLocation, currentQty)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      if (showAddAlltoCart && resultsStore) {
        resultsStore.updateMultiPartInquiryResults(
          product,
          activeLocation,
          currentQty
        )
      }
    }, [activeLocation, currentQty, product, resultsStore, showAddAlltoCart])

    const isExactMatch = isExatcMatch

    useEffect(() => {
      if (!resultsStore) {
        return
      }
      resultsStore.setUpdatedPartInfoDetails({
        product,
        updatedQty: currentQty,
        updatedLocation: activeLocation,
      })
      searchStore.setUpdatedPartInfoDetails({
        product,
        updatedQty: currentQty,
        updatedLocation: activeLocation,
      })
    }, [activeLocation, currentQty, product, resultsStore, searchStore])

    // additional options menu

    const [addtionalOptionsAnchorEl, setAddtionalOptionsAnchorEl] =
      useState<null | HTMLElement>(null)
    const openAddtionalOptionsMenu = Boolean(addtionalOptionsAnchorEl)
    const handleAdditionalOptionsClick = (
      event: React.MouseEvent<HTMLDivElement>
    ) => {
      setAddtionalOptionsAnchorEl(event.currentTarget)
    }
    const handleAdditionalOptionsClose = () => {
      setAddtionalOptionsAnchorEl(null)
    }

    // more actions menu

    const [moreActionsAnchorEl, setMoreActionsAnchorEl] =
      useState<null | HTMLElement>(null)
    const moreActionsMenu = Boolean(moreActionsAnchorEl)

    const handleMoreActionsClick = (
      event: React.MouseEvent<HTMLButtonElement>
    ) => {
      setMoreActionsAnchorEl(event.currentTarget)
    }
    const handleMoreActionsClose = () => {
      setMoreActionsAnchorEl(null)
    }
    function handleTooltipDisplay() {
      if (!sellerDetails || !sellerDetails.coverageKey) {
        return false
      }
      const key = `${userId}_multiseller_tooltip_display`
      const storedValue = localStorage.getItem(key)

      if (storedValue === null) {
        localStorage.setItem(key, 'true')
        return true
      }

      return storedValue === 'true'
    }

    const handleDeletePart = () => {
      const seller = getSelectedSeller() ?? MY_PLACE_SELLER

      store.dispatch(
        removeProductThunk({
          product,
          quantity: ABSOLUTE_MAX_QUANTITY,
          locationId: activeLocation.locationId.toString(),
          vehicle: selectedCurrentVehicle,
          seller,
          removeFromAllLocations: true,
        })
      )
    }

    const { onInputTooltipMsg, shouldShowLocationSelector } =
      useQuantitySelectorToolbox(cartProduct)

    const updateQuantityRef = useRef(updateQuantity)
    updateQuantityRef.current = updateQuantity

    const activeLocationRef = useRef(activeLocation)
    activeLocationRef.current = activeLocation

    const handleQtyChange = useCallback(
      (newQty: number): Promise<void> => {
        setPriceSpinner?.(true)
        return updateQuantityRef
          .current(newQty, activeLocationRef.current)
          .then(() => {
            // To satisfy TS void.
          })
      },
      [setPriceSpinner]
    )

    const isPrimary = activeLocation?.locType === 'primary'

    return (
      <DesktopViewCard
        green={green}
        isCondensedView={isCondensedView}
        data-product-key={getProductKey(product)}
      >
        <Td green={green}>
          <Cell className="align-items-center justify-content-center">
            <ThumbnailWrapper onClick={navigateToProductDetails}>
              <Thumbnail urlOrBase64={productImage} width={100} placeholder />
            </ThumbnailWrapper>

            {brandImgUrl && (
              <BrandWrapper
                onClick={() => {
                  setShowBrandLinksDrawer(true, product)
                }}
              >
                <Thumbnail urlOrBase64={brandImgUrl} width={100} alt="brand" />
              </BrandWrapper>
            )}
            <BrandWrapperNoInfo isCondensedView={isCondensedView}>
              {!brandImgUrl && product.brandName && product.brandName}
              {!brandImgUrl && !product.brandName && product.manufacturerName}
            </BrandWrapperNoInfo>
          </Cell>
        </Td>
        <Td>
          <Cell>
            {alternateFor || replacementFor ? (
              <ProductName isLink={false} isCondensedView={isCondensedView}>
                {description}
              </ProductName>
            ) : (
              <ProductName
                isLink
                onClick={navigateToProductDetails}
                isCondensedView={isCondensedView}
              >
                {description}
              </ProductName>
            )}
            {searchStore.showPartsNotFitVehicleLabel &&
              searchStore?.currentVehicle.engine?.value && (
                <CardIconContainer>
                  <CardIcon src={carIcon} alt="Car Icon" />
                  <MessageCardIcon>
                    <I18n name="mayNotFitYour" />
                  </MessageCardIcon>
                </CardIconContainer>
              )}
            {replacementFor && (
              <ReplacementTag>{replacementFor.partNumber}</ReplacementTag>
            )}
            {alternateFor && (
              <AlternateTag>{alternateFor.partNumber}</AlternateTag>
            )}
            {showFullDesc && extendedDescription && (
              <Description isCondensedView={isCondensedView}>
                {extendedDescription} &nbsp;
                {extendedDescription.length > extenDescSupposeLength && (
                  <ReadMore
                    onClick={() => setShowFullDesc(false)}
                    isCondensedView={isCondensedView}
                  >
                    [<I18n name="readLess" />]
                  </ReadMore>
                )}
              </Description>
            )}
            {!showFullDesc && (
              <Description
                onClick={() => setShowFullDesc(true)}
                isCondensedView={isCondensedView}
              >
                {extendedDescription.substring(0, extenDescSupposeLength)}
                ...&nbsp;
                <ReadMore isCondensedView={isCondensedView}>
                  [<I18n name="readMore" />]
                </ReadMore>
              </Description>
            )}
            {warrantyDescription && (
              <div className="mt-3" style={{ maxWidth: 250 }}>
                <b>
                  <I18n name="warrantyInfo" />
                  :&nbsp;
                </b>
                {warrantyDescription}
              </div>
            )}
            {product?.unAnsweredSpecificConditions?.length > 0 && (
              <FitsConditions>
                <Info className="fitmentInfoIcon" />{' '}
                {product?.unAnsweredSpecificConditions?.map((item, idx) => (
                  <>
                    {item}&nbsp;
                    {idx < product.unAnsweredSpecificConditions.length - 1 && (
                      <>|&nbsp;</>
                    )}
                  </>
                ))}
              </FitsConditions>
            )}
            {!hideRoutingDiagramContent && (
              <>
                <div className="d-flex">
                  {isCondensedView && (
                    <LocalLink onClick={handleAdditionalOptionsClick}>
                      <I18n
                        name="additionalOptions"
                        style={{ fontSize: '14px' }}
                      />
                    </LocalLink>
                  )}
                  <Menu
                    id="additional-options-menu"
                    anchorEl={addtionalOptionsAnchorEl}
                    open={openAddtionalOptionsMenu}
                    onClose={handleAdditionalOptionsClose}
                    MenuListProps={{
                      'aria-labelledby': 'additional-options-button',
                      sx: { py: 0 },
                    }}
                  >
                    <MultiSellerInterchangeTooltip
                      show={showTooltip && handleTooltipDisplay()}
                    >
                      <MenuItem
                        onClick={() => {
                          getInterchangeParts(partNumber, 'add')
                          handleAdditionalOptionsClose()
                        }}
                        onMouseEnter={() => {
                          setShowTooltip(true)
                        }}
                        onMouseLeave={() => setShowTooltip(false)}
                        sx={{ color: defaultTheme.colors.link }}
                      >
                        <SwapHorizIcon
                          sx={{ marginRight: '5px', width: '14px' }}
                        />

                        <I18n name="interchange" style={{ fontSize: '14px' }} />
                      </MenuItem>
                    </MultiSellerInterchangeTooltip>

                    {vehicleFitment &&
                      !replacementFor &&
                      !alternateFor &&
                      showNonASTLinks && (
                        <MenuItem
                          onClick={() => {
                            handleClickVehicleFitment()
                            handleAdditionalOptionsClose()
                          }}
                          sx={{ color: defaultTheme.colors.link }}
                        >
                          <DirectionsCarIcon
                            sx={{ marginRight: '5px', width: '12px' }}
                          />
                          <I18n
                            name="vehicleFitment"
                            style={{ fontSize: '14px' }}
                          />
                        </MenuItem>
                      )}

                    {showGFX && (
                      <MenuItem
                        onClick={() => {
                          parseAllEngines(
                            {
                              id: product?.group?.id?.toString(),
                              value: findGroupValue(
                                product?.group?.id?.toString()
                              ),
                            },
                            getCategoryId(product?.group?.id.toString())
                          )
                          handleAdditionalOptionsClose()
                        }}
                        sx={{ color: defaultTheme.colors.link }}
                      >
                        <CardIcon
                          src={gfxCatalogIcon}
                          alt="GFX Catalog"
                          style={{
                            marginRight: '5px',
                            width: '12px',
                            color: defaultTheme.colors.link,
                          }}
                        />
                        <I18n name="gfxCatalog" style={{ fontSize: '14px' }} />
                      </MenuItem>
                    )}

                    {isApplicationPart() &&
                      showNonASTLinks &&
                      shouldShowLaborLink && (
                        <MenuItem
                          onClick={() => {
                            handleLaborLookup()
                            handleAdditionalOptionsClose()
                          }}
                          sx={{ color: defaultTheme.colors.link }}
                        >
                          <HomeRepairService
                            fontSize="inherit"
                            sx={{ marginRight: '5px', width: '12px' }}
                          />
                          <I18n name="labor" style={{ fontSize: '14px' }} />
                        </MenuItem>
                      )}
                  </Menu>
                </div>
                <PartMessage message={product?.partMessage?.[0]} />
                <div
                  style={{
                    display: 'flex',
                    gap: '7px',
                    alignItems: 'flex-start',
                    flexWrap: 'wrap',
                  }}
                >
                  {!isCondensedView && (
                    <MultiSellerInterchangeTooltip
                      show={showTooltip && handleTooltipDisplay()}
                    >
                      <span
                        onMouseEnter={() => {
                          setShowTooltip(true)
                        }}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <InlineLink
                          onClick={() => {
                            getInterchangeParts(partNumber, 'add')
                          }}
                        >
                          <I18n name="interchange" />
                        </InlineLink>
                      </span>
                    </MultiSellerInterchangeTooltip>
                  )}
                  {vehicleFitment &&
                    !replacementFor &&
                    !alternateFor &&
                    showNonASTLinks &&
                    !isCondensedView && (
                      <InlineLink
                        onClick={() => {
                          handleClickVehicleFitment()
                        }}
                      >
                        <I18n name="vehicleFitment" />
                      </InlineLink>
                    )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: '7px',
                    alignItems: 'flex-start',
                    flexWrap: 'wrap',
                  }}
                >
                  {showGFX && !isCondensedView && (
                    <InlineLink
                      onClick={() =>
                        parseAllEngines(
                          {
                            id: product?.group?.id?.toString(),
                            value: findGroupValue(
                              product?.group?.id?.toString()
                            ),
                          },
                          getCategoryId(product?.group?.id.toString())
                        )
                      }
                    >
                      <I18n name="gfxCatalog" />
                    </InlineLink>
                  )}
                  {isApplicationPart() &&
                    showNonASTLinks &&
                    shouldShowLaborLink &&
                    !sellerDetails?.coverageKey &&
                    !isCondensedView && (
                      <InlineLink onClick={handleLaborLookup}>
                        <I18n name="labor" />
                      </InlineLink>
                    )}
                </div>
              </>
            )}
          </Cell>
        </Td>
        <Td>
          <Cell>
            {isExactMatch && (
              <ExactMatchContainer>
                <IconCheck></IconCheck>
                <ExactMatchLabel>
                  <I18n name="exactMatch" />
                </ExactMatchLabel>
              </ExactMatchContainer>
            )}

            <NoWrap isCondensedView={isCondensedView}>
              <span style={{ whiteSpace: 'nowrap' }}>
                <I18n name="partNum" />
                :&nbsp;
              </span>
              <b>{partNumber}</b>
            </NoWrap>
            <NoWrap isCondensedView={isCondensedView}>
              <I18n name="lineCode" />: <b>{lineCode}</b>
            </NoWrap>
            {lastNonCachedSearch === NonCachedSearchType.searchByNavigation && (
              <>
                <NoWrap isCondensedView={isCondensedView}>
                  <I18n name="fitsYears" />: <b>{fromYear}</b>
                </NoWrap>
                <NoWrap isCondensedView={isCondensedView}>
                  <I18n name="perCarQty" />: <b>{perCarQty}</b>
                </NoWrap>
              </>
            )}
          </Cell>
        </Td>
        {hideRoutingDiagramContent && (
          <>
            <td />
            <td />
            <td />
          </>
        )}
        {!hideRoutingDiagramContent && (
          <>
            <Td>
              {priceSpinner && (
                <Cell style={{ gap: '20px' }}>
                  <Skeleton variant="rectangular" width={210} />
                  <Skeleton variant="rectangular" width={210} />
                </Cell>
              )}
              {!priceSpinner && (
                <Cell style={{ alignItems: 'start' }}>
                  {invDisplayState ===
                    InventoryDisplay.AVAILABLE_AT_LOCATION && (
                    <Wrap className="fw-bold" isCondensedView={isCondensedView}>
                      {activeLocation?.locType === LocationType.VIEW_ONLY && (
                        <StyledWarning theme={defaultTheme} />
                      )}
                      {qtyAvailable}&nbsp;
                      <I18n name="at" />
                      &nbsp;
                      {locType === 'primary' && (
                        <Store htmlColor={defaultTheme.colors.green} />
                      )}
                      {called}
                      {isPrimary && (
                        <SubLocationQtyInfo>
                          <I18n
                            name="atOtherLocations"
                            textReplacement={[
                              getNonPrimaryLocationsQtyAvailable,
                            ]}
                          />
                        </SubLocationQtyInfo>
                      )}
                      {!isPrimary && (
                        <SubLocationQtyInfo>
                          {getPrimaryLocationQtyAvailable.qty}&nbsp;
                          <I18n name="at" />
                          &nbsp;
                          <Store htmlColor={defaultTheme.colors.greyDark} />
                          {getPrimaryLocationQtyAvailable.called}
                        </SubLocationQtyInfo>
                      )}
                    </Wrap>
                  )}
                  {invDisplayState === InventoryDisplay.SHOW_ZERO && (
                    <Wrap className="fw-bold" isCondensedView={isCondensedView}>
                      {!inStockSomewhere && isZeroCost ? (
                        <>
                          <NotInterested htmlColor={defaultTheme.colors.red} />
                          <I18n name="callForAvailability" />
                        </>
                      ) : (
                        <>
                          <I18n
                            name="zeroAvailableAtLocation"
                            textReplacement={[called]}
                          />
                          {isPrimary && (
                            <SubLocationQtyInfo>
                              <I18n
                                name="atOtherLocations"
                                textReplacement={[
                                  getNonPrimaryLocationsQtyAvailable,
                                ]}
                              />
                            </SubLocationQtyInfo>
                          )}
                          {!isPrimary && (
                            <SubLocationQtyInfo>
                              {getPrimaryLocationQtyAvailable.qty}&nbsp;
                              <I18n name="at" />
                              &nbsp;
                              <Store htmlColor={defaultTheme.colors.greyDark} />
                              {getPrimaryLocationQtyAvailable.called}
                            </SubLocationQtyInfo>
                          )}
                        </>
                      )}
                    </Wrap>
                  )}
                  {invDisplayState ===
                    InventoryDisplay.CALL_FOR_AVAILABILITY && (
                    <>
                      <Wrap className="fw-bold">
                        <Error htmlColor={defaultTheme.colors.primary} />
                        &nbsp;
                        <I18n name="callForAvailability" />
                      </Wrap>
                      <Description>
                        <I18n name="itemUnavailableAtAllLocations" />
                        <br />
                        {contactNumber && (
                          <I18n
                            name="pleaseContactForInformation"
                            textReplacement={[contactNumber]}
                          />
                        )}
                      </Description>
                    </>
                  )}
                  {activeLocation?.locType === LocationType.VIEW_ONLY && (
                    <I18n
                      name="viewOnlyLocationMessage"
                      style={{ width: '150px' }}
                    />
                  )}
                  {activeLocation?.locType ===
                    LocationType.ORDER_FROM_PRIMARY && (
                    <WarningLabel
                      name="orderFromPrimaryWarining"
                      style={{
                        width: '150px',
                      }}
                    />
                  )}
                  {inStockSomewhere && (
                    <Wrap isCondensedView={isCondensedView}>
                      <LocalLink
                        onClick={showLocationSelector}
                        style={{
                          ...(isCondensedView && { marginTop: '4px' }),
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {!isPrimary ? (
                          <SubLocationQtyInfo>
                            <I18n
                              name="atOtherLocations"
                              textReplacement={[getOtherLocationsQtyAvailable]}
                            />
                          </SubLocationQtyInfo>
                        ) : (
                          <I18n name="moreLocations" />
                        )}
                      </LocalLink>
                    </Wrap>
                  )}
                </Cell>
              )}
            </Td>
            <Td style={{ minWidth: 230, paddingLeft: '10px' }}>
              <Prices cartProduct={cartProduct} />
            </Td>
            <Td>
              <Cell style={{ alignItems: 'normal' }}>
                <ControlsColumn>
                  <QuantitySelector
                    orderIfNotAvailable={orderIfNotAvailable && isPrimary}
                    onChange={handleQtyChange}
                    onRemove={() => undefined}
                    onClick={shouldShowLocationSelector}
                    minQty={Math.max(
                      activeLocation?.minQty,
                      activeLocation?.buyIncrement || 0
                    )}
                    stepSize={activeLocation?.buyIncrement}
                    onInputHoverTooltipMsg={onInputTooltipMsg}
                    orderNumber={orderNumber}
                    isStoked={isStocked}
                    value={currentQty.toString()}
                    setValue={(val) => setCurrentQty(Number(val))}
                    isCondensedView={isCondensedView}
                    isLoading={priceSpinner}
                    fullWidth
                  />
                  {!inCart && (inStockSomewhere || orderIfNotAvailable) && (
                    <ButtonWrapper style={{ marginTop: isCondensedView && 0 }}>
                      <AddButton
                        onClick={handleAddToCart}
                        text="addToCart"
                        disabled={disableAddToCart}
                        style={{
                          height: isCondensedView && '32px',
                          fontSize: isCondensedView && '14px',
                          marginTop: isCondensedView && '12px',
                        }}
                        loading={addToCartInProgress}
                      />
                    </ButtonWrapper>
                  )}
                  {!inStockSomewhere && !orderIfNotAvailable && (
                    <ButtonWrapper style={{ marginTop: isCondensedView && 0 }}>
                      <AddButton
                        text="addToCart"
                        disabled
                        style={{
                          height: isCondensedView && '32px',
                          fontSize: isCondensedView && '14px',
                          marginTop: isCondensedView && '12px',
                        }}
                      />
                    </ButtonWrapper>
                  )}
                  {inCart && (
                    <ButtonWrapper>
                      <AddButton
                        text={inCartText}
                        variant="success"
                        style={{
                          height: isCondensedView && '32px',
                          fontSize: isCondensedView && '14px',
                        }}
                        onClick={handleAddToCart}
                      />
                      <DeleteWrapper onClick={handleDeletePart}>
                        <DeleteButton />
                      </DeleteWrapper>
                    </ButtonWrapper>
                  )}

                  {isCondensedView && (
                    <MoreActionsWrapper>
                      <Button
                        onClick={handleMoreActionsClick}
                        text="moreActions"
                        variant="transparent"
                        icon={
                          !moreActionsMenu ? (
                            <KeyboardArrowDown
                              sx={{
                                m: 0,
                                marginRight: '2px',
                              }}
                            />
                          ) : (
                            <KeyboardArrowUp
                              sx={{
                                m: 0,
                                marginRight: '2px',
                              }}
                            />
                          )
                        }
                        style={{
                          height: '32px',
                          fontSize: '14px',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          margin: 0,
                          padding: 0,
                        }}
                      />
                      <Menu
                        id="more-actions-menu"
                        anchorEl={moreActionsAnchorEl}
                        open={moreActionsMenu}
                        onClose={handleMoreActionsClose}
                        MenuListProps={{
                          'aria-labelledby': 'more-actions-button',
                          sx: {
                            width: '168px',
                          },
                        }}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 0,
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            handleAddToList()
                            handleMoreActionsClose()
                          }}
                        >
                          <I18n
                            name="addToList"
                            style={{ fontSize: '14px', fontWeight: 'bold' }}
                          />
                        </MenuItem>
                        {!sellerDetails?.coverageKey && (
                          <MenuItem
                            onClick={() => {
                              handleMoreActionsClose()
                              handleLostSale()
                            }}
                          >
                            <I18n
                              name="reportLostSale"
                              style={{ fontSize: '14px', fontWeight: 'bold' }}
                            />
                          </MenuItem>
                        )}
                      </Menu>
                    </MoreActionsWrapper>
                  )}

                  {import.meta.env.VITE_FEATURE_LISTS_ENABLED === 'true' &&
                    !isCondensedView && (
                      <ButtonWrapper>
                        <AddButton
                          onClick={handleAddToList}
                          text="addToList"
                          variant="secondary"
                        />
                      </ButtonWrapper>
                    )}

                  {!isCondensedView && !sellerDetails?.coverageKey && (
                    <LocalLink onClick={handleLostSale}>
                      <I18n name="reportLostSale" />
                    </LocalLink>
                  )}
                </ControlsColumn>
              </Cell>
            </Td>
          </>
        )}
      </DesktopViewCard>
    )
  }
)

interface RowProps {
  green?: boolean
  isCondensedView?: boolean
}

const Row = styled.tr<RowProps>`
  background: ${(props) =>
    props.green
      ? defaultTheme.colors.gfxBackground
      : defaultTheme.colors.componentsBackground};
  border: 24px;
  max-width: 100%;
  box-shadow: inset 0px -1px 0px ${defaultTheme.colors.border};
`

const DesktopViewCard = styled(Row)`
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: none;
  }
`

interface TdProps {
  green?: boolean
  width?: string
}

const Td = styled.td<TdProps>`
  box-sizing: border-box;
  border-left: ${(props) =>
    props.green ? `12px solid ${defaultTheme.colors.gfxBorder}` : 'none'};
  vertical-align: top;
  padding: 16px 14px;
  max-width: ${(p) => (p.width ? `${p.width}` : '')};
`

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 16px;
  line-height: 24px;
  text-align: start;
`

const ControlsColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 230px;
`

interface ProductNameProps {
  isLink: boolean
  isCondensedView?: boolean
}

const ProductName = styled.div<ProductNameProps>`
  font-family: Oswald, serif;
  font-size: ${(p) => (p.isCondensedView ? '16px' : '20px')};
  font-weight: bold;
  line-height: ${(p) => (p.isCondensedView ? '24px' : '30px')};
  text-decoration: ${(p) => (p.isLink ? 'underline' : 'none')};
  max-width: 250px;
  cursor: ${(p) => (p.isLink ? 'pointer' : 'initial')};
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    text-align: left;
  }
`
interface IsCondensedViewProps {
  isCondensedView?: boolean
}

const Description = styled.div<IsCondensedViewProps>`
  font-family: Roboto, serif;
  font-size: ${(p) => (p.isCondensedView ? '14px' : '16px')};
  line-height: 24px;
  text-align: left;
  margin-top: 12px;
  max-width: 250px;
`

const Wrap = styled.span<IsCondensedViewProps>`
  white-space: normal;
  font-size: ${(p) => p.isCondensedView && '14px'};
`

const NoWrap = styled.span<IsCondensedViewProps>`
  white-space: nowrap;
  font-size: ${(p) => p.isCondensedView && '14px'};
`

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0 0;
  width: 100%;
`
const DeleteWrapper = styled.div`
  padding: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${defaultTheme.colors.siteBackground};
  cursor: pointer;
  border-radius: 3px;
  flex-basis: 48px;
`
const AddButton = styled(Button)`
  width: 100%;
  box-sizing: border-box;
  margin-left: 0px;
  margin-right: 0px;
`
const DeleteButton = styled(Delete)`
  color: ${defaultTheme.colors.greyDark};
`
const LocalLink = styled.div`
  color: ${defaultTheme.colors.link};
  text-decoration: underline;
  cursor: pointer;
  margin: 10px 0 0;
  width: 100%;
  text-align: center;
`

const InlineLink = styled.div`
  color: ${defaultTheme.colors.link};
  text-decoration: underline;
  cursor: pointer;
  margin: 10px 0 0;
  word-break: break-word;
  display: inline-block;
`

const ReadMore = styled.span<IsCondensedViewProps>`
  font-weight: bold;
  cursor: pointer;
  font-size: ${(p) => p.isCondensedView && '14px'};
`
const CardIconContainer = styled.div`
  background: ${defaultTheme.colors.componentsBackground};
  height: 36px;
  display: flex;
  align-items: center;
  padding: 12px 7px;
  margin-top: 12px;
  background-color: rgb(243, 242, 238);
`

const CardIcon = styled.img`
  width: 18px;
  height: 18px;
`

const MessageCardIcon = styled.p`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${defaultTheme.colors.primaryText};
  margin: 0 0 0 8px;
`

const BrandWrapper = styled.div`
  margin-top: 20px;
  cursor: pointer;
`
const BrandWrapperNoInfo = styled.div<IsCondensedViewProps>`
  margin-top: 0;
  font-size: ${(p) => p.isCondensedView && '14px'};
`

const FitsConditions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px;
  gap: 8px;
  min-height: 38px;
  max-width: 300px;
  background: ${defaultTheme.colors.greyVeryLight};
  border-radius: 2px;
  flex: none;
  order: 1;
  flex-grow: 0;
  margin-top: 6px;
  white-space: normal;

  .fitmentInfoIcon {
    align-self: start;
    fill: ${defaultTheme.colors.greyDark};
    width: 16px;
  }
`

const ThumbnailWrapper = styled.div`
  cursor: pointer;
`
const ExactMatchContainer = styled.div`
  display: flex;
  padding: 0px 4px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #ecf5e1;
  min-height: 24px;
  margin-bottom: 8px;
`

const IconCheck = styled(Check)`
  width: 18px;
  height: 18px;
`

const ExactMatchLabel = styled.span`
  color: ${defaultTheme.colors.almostBlack};
  font-variant-numeric: lining-nums tabular-nums;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`

const StyledWarning = styled(Warning)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 18px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 5px;
`

const MoreActionsWrapper = styled.div`
  width: 168px;
  height: 32px;
  margin-top: 4px;
  border-radius: 3px;
  border: 1px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
`

const SubLocationQtyInfo = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  font-family: Roboto;
`
